const FALLBACK_LOGO_SRC = '/logo.svg';

export const sanitizeUrl = (value: unknown): string | null => {
  if (typeof value !== 'string') return null;

  const trimmed = value.trim();
  if (!trimmed) return null;

  try {
    const parsed = new URL(trimmed);
    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return null;
    return trimmed;
  } catch {
    return null;
  }
};

export const buildGoogleFaviconUrl = (websiteUrl: string | null): string | null => {
  const safeWebsite = sanitizeUrl(websiteUrl);
  if (!safeWebsite) return null;

  try {
    const domain = new URL(safeWebsite).hostname;
    return `https://www.google.com/s2/favicons?domain=${encodeURIComponent(domain)}&sz=128`;
  } catch {
    return null;
  }
};

export const resolveToolLogoSource = (logoUrl: string | null, websiteUrl?: string | null): string => {
  return sanitizeUrl(logoUrl) ?? buildGoogleFaviconUrl(websiteUrl ?? null) ?? FALLBACK_LOGO_SRC;
};

export const getFallbackLogoSource = (): string => FALLBACK_LOGO_SRC;

const OPTIMIZED_DOMAINS = [
  'via.placeholder.com',
  'huaiznjeysnkudqobdie.supabase.co',
  'ui-avatars.com',
  'images.unsplash.com',
  'static.grammarly.com',
  'www.lexisnexis.com',
];

export const canOptimizeUrl = (urlStr: string | null | undefined): boolean => {
  if (!urlStr) return false;
  if (urlStr.startsWith('/') || urlStr.startsWith('.')) return true;

  try {
    const parsed = new URL(urlStr);
    return OPTIMIZED_DOMAINS.some(
      (domain) => parsed.hostname === domain || parsed.hostname.endsWith('.' + domain)
    );
  } catch {
    return false;
  }
};
